import axios from 'axios';
import { Toast } from '@douyinfe/semi-ui';
import { siteConfig } from '../config';

// 创建axios实例
const request = axios.create({
  baseURL: siteConfig.api.apiBaseUrl,
  timeout: 10000,
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const tokenObj = JSON.parse(token);
        config.headers['PHPSESSID'] = token;
        config.headers['zoneid'] = tokenObj.z;
        config.headers['spuid'] = tokenObj.s;
      } catch (error) {
        console.error('Token解析失败:', error);
      }
    }
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.errno === 402) {
      // 保存当前页面URL
      localStorage.setItem('redirectUrl', window.location.pathname);
      // 跳转到登录页面
      window.location.href = '/login';
      return Promise.reject(new Error('未登录'));
    }
    return res;
  },
  error => {
    console.error('响应错误:', error);
    Toast.error('网络请求失败，请检查网络连接');
    return Promise.reject(error);
  }
);

export default request;